import React from 'react';
import {
  Controls,
  InlineControl,
  SubHeader,
  Text,
  TextFormat,
} from '../../reporting/sidebar/components';

function ChartTitle() {
  return (
    <>
      <SubHeader>Title</SubHeader>
      <Controls>
        <InlineControl>
          <TextFormat
            configurationKey='titleFormat'
            defaultSize={18}
            defaultColor='black'
            defaultFontWeight='bold'
            defaultFontStyle='normal'
          />
        </InlineControl>

        <InlineControl>
          <Text configurationKey='chartTitle' size='large' />
        </InlineControl>
      </Controls>
    </>
  );
}
export default ChartTitle;
